import { t } from '@lingui/macro';

export const getDefaultRejectReason = (hasMultipleOffers: boolean) => {
  if (hasMultipleOffers) {
    return t`These offers were rejected.`;
  } else {
    return t`This offer was rejected.`;
  }
};
